import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as storageConstants from "../Constants/storageConstant";
import { PAGE_NOT_ACCESSABLE } from "../Constants/stringConstants";
import * as commonServices from "../Services/common";
import canAccessModule from "../Utils/permissionUtils";
import { warn } from "../Wrapper/toast/toast";

const ProtectedRoute = ({
  Component,
  configControl,
  pageName,
  moduleName,
  dropdownconfigControl,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isAuthenticated = commonServices.getLocalData(storageConstants.AUTH);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/");
      return;
    } else if (isAuthenticated) {
      if (location.pathname === "/") {
        navigate(
          commonServices.isTherapist() || commonServices.isStaff() ? "/dashboard" : "/patients",
        );
      } else if (
        (moduleName && !canAccessModule(moduleName)) ||
        !commonServices.canAccessPage(pageName)
      ) {
        navigate("/dashboard");
        warn(PAGE_NOT_ACCESSABLE);
      }
    }
  }, [isAuthenticated, moduleName, pageName, location.pathname, navigate]);

  return <>{isAuthenticated || location.pathname === "/" ? Component : navigate("/")}</>;
};

export default ProtectedRoute;
